<div class="wrapper">
  <div class="block-center mt-4 wd-xl">

    <div class="card card-flat shadow-sm">

      <div class="card-header text-center bg-primary text-white">
        <img src="assets/img/icons4u-logo-horizontal-cinza.png" alt="icons4u" width="150"><h4 class="mb-0 mt-3">Dashboard · Entrar</h4>
      </div>

      @if (operacao === 'auto') {
        <div class="card-body text-center">
          <div class="py-5">
            <img class="loading-auto mb-3" src="assets/img/loader.svg" alt="carregando">
            <p class="text-muted">Carregando...</p>
          </div>
        </div>
      }

      @if (operacao === 'setup') {
        <div class="card-body text-center">
          <div class="py-4">
            <img class="loading-auto mb-3" src="assets/img/loader.svg" alt="carregando">
            @if (errorFiltro) {
              <div class="alert alert-danger mt-3" role="alert">
                {{errorFiltro}}
              </div>
            }
            <div class="d-grid mt-4">
              <button class="btn btn-outline-secondary" (click)="voltarLogin()">VOLTAR AO LOGIN</button>
            </div>
          </div>
        </div>
      }

      @if (operacao === 'manual') {
        <div class="card-body">
          <p class="text-center text-muted mb-4">Faça o login para continuar</p>
          <form [formGroup]="valForm" class="mb-3" role="form" name="loginForm" novalidate="" (submit)="submitForm($event, valForm.value)">
            <div class="form-group mb-3">
              <div class="input-group">
                <input class="form-control"
                  id="exampleInputEmail1"
                  type="text"
                  name="cpf"
                  placeholder="CPF" aria-label="CPF"
                  autocomplete="username"
                  formControlName="cpf"
                  required />
                <span class="input-group-text bg-transparent">
                  <em class="fa fa-user text-muted"></em>
                </span>
              </div>
              @if (valForm.controls['cpf'].hasError('required') && (valForm.controls['cpf'].dirty || valForm.controls['cpf'].touched)) {
                <div class="invalid-feedback d-block">
                  Este campo é obrigatório
                </div>
              }
            </div>
            <div class="form-group mb-3">
              <div class="input-group">
                <input class="form-control"
                  id="exampleInputPassword1"
                  type="password"
                  name="password"
                  placeholder="Senha" aria-label="Senha"
                  autocomplete="current-password"
                  formControlName="password"
                  required />
                <span class="input-group-text bg-transparent">
                  <em class="fa fa-lock text-muted"></em>
                </span>
              </div>
              @if (valForm.controls['password'].hasError('required') && (valForm.controls['password'].dirty || valForm.controls['password'].touched)) {
                <div class="invalid-feedback d-block">
                  Este campo é obrigatório
                </div>
              }
            </div>
            <div class="d-flex justify-content-between align-items-center mb-4">
              <div class="form-check">
                <input class="form-check-input"
                  type="checkbox"
                  id="remember"
                  name="remember"
                  formControlName="remember" />
                <label class="form-check-label" for="remember">
                  Lembrar-me
                </label>
              </div>
              <div>
                <a class="text-decoration-none" [routerLink]="'/recuperar-senha'">Esqueceu a senha?</a>
              </div>
            </div>
            <div class="d-grid mb-3">
              <button class="btn btn-primary btn-lg" type="submit">ENTRAR</button>
            </div>
          </form>
          @if (errorMessage != '') {
            <div class="alert alert-danger" role="alert">
              {{errorMessage}}
            </div>
          }
          <div class="text-center text-muted small border-top pt-3">
            <span>&copy;</span>
            <span>{{ settings.getAppSetting('year') }}</span>
            <span class="mx-2">-</span>
            <span>{{ settings.getAppSetting('name') }}</span>
          </div>
        </div>
      }
    </div>

  </div>
</div>
